export function getProductTilePlaceholderUrl(placeholder: string, baseImageUrl?: string): string | undefined {
    if (/^(?:https?:)?\/\//i.test(placeholder)) {
        return placeholder;
    }
    if (!baseImageUrl) {
        return undefined;
    }
    try {
        const url = new URL(baseImageUrl);
        if (url.pathname.endsWith('/imageFileData/search')) {
            url.searchParams.set('fileName', placeholder);
            url.searchParams.delete('fallback');
            return url.toString();
        }
        return new URL(placeholder, baseImageUrl).toString();
    } catch {
        return undefined;
    }
}